import { Form, Input } from "antd";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useRouteMatch } from "react-router-dom";
import {
  addDataToAllergyMedicationTable,
  book_appointment,
  book_Videoconsultaton,
  Store_formData,
} from "../../../../../../actions/InterBranchCoordinatorAction";
import {
  INTERBRANCH_CLEAR_TEMP_APPOINTMENT_FORM,
  INTERBRANCH_MODAL_UPDATE,
  INTERBRANCH_UPDATE_TEMP_APPOINTMENT_FORM,
} from "../../../../../../actions/type";
import {
  ADD_DATA_TO_ALLERGY_MEDICATION_REDUX,
  allergentOptions,
  allergyStatusOptions,
  EDIT_DATA_TO_ALLERGY_MEDICATION_REDUX,
  medicinesOptions,
  sinceOptions,
  statusOptions,
} from "../../../../../../Helpers/InterBranchConstants";
import {
  ALLERGY_REDUX_STATE,
  COMMON_DELETE_MODAL_NAME,
  MEDICINE_REDUX_STATE,
} from "../../../../../../Helpers/InterBranchConstants";
import { update_allergy_medication_info } from "../../../../../../actions/InterBranchCoordinatorAction";
import Dropdown from "../../../../../DropDown/Dropdown";
import "./allergiesandmedication.css";
import { ConsoleSqlOutlined } from "@ant-design/icons";

function AllergiesandMedication() {
  let dispatch = useDispatch();
  let history = useHistory();
  let { path, url } = useRouteMatch();
  let reduxData = useSelector((state) => state);
  let patientId =
    reduxData?.interBranchCoordinator?.interBranchRegisterPatient?.data?.info;

  const allergies = useSelector(
    (state) => state?.interBranchCoordinator?.temp_appointment_form?.allergies
  );
  const medications = useSelector(
    (state) => state?.interBranchCoordinator?.temp_appointment_form?.medications
  );

  let appointment_form = useSelector(
    (state) => state?.interBranchCoordinator?.appointment_form
  );
  let temp_appointment_form = useSelector(
    (state) => state?.interBranchCoordinator?.temp_appointment_form
  );

  let userDetails = JSON.parse(localStorage.getItem("userData"));
  const userId = userDetails.profileId;
  let {
    chosendoctorId,
    chosenDate,
    chosenTime,
    typeOfConsultation,
    couponCode,
  } = reduxData?.interBranchCoordinator?.appointment_form;

  const [allergyForm] = Form.useForm();
  const [medicationForm] = Form.useForm();

  const [isEditted, setEditted] = useState(false);

  useEffect(() => {
    preloadData();

    return () => dispatch({ type: INTERBRANCH_CLEAR_TEMP_APPOINTMENT_FORM });
  }, []);

  useEffect(() => {
    if (allergies?.length > 0 || medications?.length > 0) {
      setEditted(true);
    } else {
      setEditted(false);
    }
  }, [allergies, medications]);

  const preloadData = () => {
    dispatch({
      type: INTERBRANCH_UPDATE_TEMP_APPOINTMENT_FORM,
      payload: {
        allergies: appointment_form?.allergies,
        medications: appointment_form?.medications,
      },
    });
  };

  let videoconsultation = () => {
    try {
      dispatch(
        book_Videoconsultaton(
          patientId,
          userId,
          chosendoctorId,
          typeOfConsultation,
          couponCode,
          chosenTime,
          chosenDate,
          appointment_form
        )
      ).then((res) => {
        if (
          res.data.appointmentId !=
          "Time slot already choosen by some other person. Please try with different slot, Sorry for the inconvenience."
        ) {
          localStorage.setItem("AppointmentId", res.data.appointmentId);
          history.push("/joinconsultation/" + res.data.appointmentId);
        }
      });
    } catch (error) {
      //console.log("Error in book_appointment API", error);
    }
  };

  let addNewRowInAllergies = () => {
    let payloadData = {
      index: allergies && allergies.length > 0 ? allergies.at(-1).index + 1 : 0,
      Allergent: null,
      Reaction: null,
      Since: null,
    };

    let tempExisting = temp_appointment_form?.allergies
      ? temp_appointment_form.allergies
      : [];
    dispatch({
      type: INTERBRANCH_UPDATE_TEMP_APPOINTMENT_FORM,
      payload: { allergies: [...tempExisting, payloadData] },
    });
  };

  let addNewMedicine = () => {
    let payloadData = {
      index:
        medications && medications.length > 0
          ? medications.at(-1).index + 1
          : 0,
      Name: null,
      Quantity: null,
      Dosage: null,
      Since: null,
      Status: null,
    };
    let tempExisting = temp_appointment_form?.medications
      ? temp_appointment_form.medications
      : [];

    dispatch({
      type: INTERBRANCH_UPDATE_TEMP_APPOINTMENT_FORM,
      payload: { medications: [...tempExisting, payloadData] },
    });
  };

  let removeAllergie = (index, name) => {
    dispatch({
      type: INTERBRANCH_MODAL_UPDATE,
      payload: {
        modalName: "deleteAllergy",
        isVisible: true,
        data: { index, name: name },
      },
    });
  };

  let removeMedicine = (index, name) => {
    dispatch({
      type: INTERBRANCH_MODAL_UPDATE,
      payload: {
        modalName: "deleteMedication",
        isVisible: true,
        data: { index, name: name },
      },
    });
  };

  let updateTable = (value, id, name, index) => {
    let stateName = id;
    let key = name;

    // //console.log(stateName, key, value, index);

    dispatch({
      type: EDIT_DATA_TO_ALLERGY_MEDICATION_REDUX,
      payload: { stateName, key, value, index },
    });
  };

  let handleSave = async () => {
    try {
      await medicationForm.validateFields();
      await allergyForm.validateFields();

      try {
        //console.log("Allergy, Medication details b4 calling API", allergies, medications);
        dispatch(
          update_allergy_medication_info(patientId, allergies, medications)
        );
      } catch (error) {
        console.log("Error in profile API", error);
      }

      history.push(
        `/dashboard/${
          url.includes("bookandconsult")
            ? "bookandconsult"
            : "scheduleappointment"
        }/consultationhistory`
      );
    } catch (error) {
      if (error?.errorFields?.length < 0 || !error) {
      }
    }
  };

  let isScheduled = () => {
    return url.includes("scheduleappointment");
  };

  let validateAlphaNumericsOnly = (event) => {
    if (!event.key.match(new RegExp("^[a-zA-Z0-9_ ]*$"))) {
      event.preventDefault();
    }
  };

  function allowOnlyNumericsOrDigits(e) {
    if (e.target.value.includes(".") && e.key == ".") {
      e.preventDefault();
    }

    ![
      "0",
      "1",
      "2",
      "3",
      "4",
      "5",
      "6",
      "7",
      "8",
      "9",
      ".",
      "Backspace",
    ].includes(e.key) && e.preventDefault();
  }

  const onFinishAllergies = (values) => {
    console.log(values);

    addNewRowInAllergies();
  };

  const onFinishFailedAllergies = (error) => {
    // console.log(error);
  };

  const onFinishMedication = (values) => {
    console.log(values);

    addNewMedicine();
  };

  const onFinishFailedMedication = (error) => {
    // console.log(error);
  };

  return (
    <>
      <div className="main-container">
        <div className="sub-container-row">
          <Form
            form={allergyForm}
            name="allergyForm"
            onFinish={onFinishAllergies}
            onFinishFailed={onFinishFailedAllergies}
            autoComplete="off"
            preserve={false}
          >
            <div className="am-table-container">
              <div className="table-header">
                <span>Allergies</span>

                <button type="submit" className="add-alergie-button">
                  <img
                    src={require("../../../../../../assets/InterBranch/PNGIcons/more.png")}
                    alt=""
                  />
                </button>
              </div>

              <table>
                <tr>
                  <th>Allergen</th>
                  <th>Reaction</th>
                  <th>Status</th>
                  <th></th>
                </tr>

                <tbody>
                  {allergies && allergies.length > 0 ? (
                    allergies.map((element, key) => {
                      return (
                        <tr key={key}>
                          <td>
                            {/* <Dropdown
                                                            name="Allergent"
                                                            id="allergies"
                                                            index={element.index}
                                                            onChange={updateTable}
                                                            data={allergentOptions}
                                                            width={"100%"}
                                                            placeholder="Select"
                                                            isV2
                                                            value={element.Allergent}
                                                        /> */}

                            <Form.Item
                              name={`Allergent${element.index}`}
                              rules={[
                                {
                                  required: true,
                                  message: "Please enter allergen",
                                },
                              ]}
                              // defaultValue={element.Allergent ? element.Allergent : undefined}
                              initialValue={
                                element.Allergent
                                  ? element.Allergent
                                  : undefined
                              }
                            >
                              <Input
                                className="reaction"
                                onChange={(e) => {
                                  updateTable(
                                    e.target.value,
                                    "allergies",
                                    "Allergent",
                                    element.index
                                  );
                                }}
                                value={
                                  element.Allergent
                                    ? element.Allergent
                                    : undefined
                                }
                                width={"100%"}
                                placeholder="Allergen"
                                onKeyDown={validateAlphaNumericsOnly}
                                maxLength={25}
                              />
                            </Form.Item>
                          </td>
                          <td>
                            <Form.Item
                              name={`Reaction${element.index}`}
                              rules={[
                                {
                                  required: true,
                                  message: "Please enter reaction",
                                },
                              ]}
                              // defaultValue={element.Reaction}
                              initialValue={element.Reaction}
                            >
                              <Input
                                className="reaction"
                                onChange={(e) => {
                                  updateTable(
                                    e.target.value,
                                    "allergies",
                                    "Reaction",
                                    element.index
                                  );
                                }}
                                value={element.Reaction}
                                width={"100%"}
                                placeholder="Reaction"
                                maxLength={200}
                                onKeyDown={validateAlphaNumericsOnly}
                              />
                            </Form.Item>
                          </td>
                          <td>
                            <Form.Item
                              name={`Since${element.index}`}
                              rules={[
                                {
                                  required: true,
                                  message: "Please select status",
                                },
                              ]}
                              // defaultValue={element.Since}
                              initialValue={element.Since}
                            >
                              <Dropdown
                                name="Since"
                                id="allergies"
                                index={element.index}
                                data={allergyStatusOptions}
                                onChange={updateTable}
                                width={"100%"}
                                placeholder="Select"
                                isV2
                                value={element.Since}
                              />
                            </Form.Item>
                          </td>

                          <td>
                            <img
                              onClick={() => {
                                removeAllergie(
                                  element.index,
                                  element.Allergent ? element.Allergent : null
                                );
                              }}
                              style={{ cursor: "pointer" }}
                              src={require("../../../../../../assets/InterBranch/PNGIcons/delete.png")}
                              alt=""
                            />
                          </td>
                        </tr>
                      );
                    })
                  ) : (
                    <tr>
                      <td colSpan={4}>
                        <div className="no-data">
                          <img
                            src={require("../../../../../../assets/InterBranch/PNGIcons/no_allergies.png")}
                            alt=""
                          />

                          <span>No data available</span>
                        </div>
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </Form>

          <Form
            form={medicationForm}
            name="medicationForm"
            onFinish={onFinishMedication}
            onFinishFailed={onFinishFailedMedication}
            autoComplete="off"
            preserve={false}
          >
            <div className="am-table-container">
              <div className="table-header">
                <span>Medication</span>

                <button type="submit" className="add-alergie-button">
                  <img
                    src={require("../../../../../../assets/InterBranch/PNGIcons/more.png")}
                    alt=""
                  />
                </button>
              </div>

              <table>
                <tr>
                  <th>Medicine Name</th>
                  <th>Quantity</th>
                  <th>Frequency</th>
                  <th colSpan={2}>Status</th>
                </tr>

                <tbody>
                  {medications && medications.length > 0 ? (
                    medications.map((element, key) => {
                      return (
                        <tr key={key}>
                          <td>
                            {/* <Dropdown
                                                            name="Name"
                                                            id="medications"
                                                            index={element.index}
                                                            data={medicinesOptions}
                                                            options={{ from: MEDICINE_REDUX_STATE, index: key, key: "Name" }}
                                                            onChange={updateTable}
                                                            width={"100%"}
                                                            placeholder="Select"
                                                            isV2
                                                            value={element.Name}
                                                        /> */}

                            <Form.Item
                              name={`Name${element.index}`}
                              rules={[
                                {
                                  required: true,
                                  message: "Please enter medicine name",
                                },
                              ]}
                              // defaultValue={element.Name}
                              initialValue={element.Name}
                            >
                              <Input
                                className="reaction"
                                maxLength={30}
                                onChange={(e) => {
                                  updateTable(
                                    e.target.value,
                                    "medications",
                                    "Name",
                                    element.index
                                  );
                                }}
                                value={element.Name}
                                width={"100%"}
                                placeholder="Name"
                                onKeyDown={validateAlphaNumericsOnly}
                              />
                            </Form.Item>
                          </td>
                          <td>
                            <Form.Item
                              name={`Quantity${element.index}`}
                              rules={[
                                {
                                  required: true,
                                  message: "Please enter quantity",
                                },
                              ]}
                              // defaultValue={element.Quantity}
                              initialValue={element.Quantity}
                            >
                              <Input
                                maxLength={4}
                                onChange={(e) => {
                                  updateTable(
                                    e.target.value,
                                    "medications",
                                    "Quantity",
                                    element.index
                                  );
                                }}
                                // onChange={(e) => { updateTable({ from: MEDICINE_REDUX_STATE, index: key, key: "Quantity", value: e.target.value }) }}
                                value={element.Quantity}
                                width={"100%"}
                                className="reaction"
                                onKeyDown={allowOnlyNumericsOrDigits}
                                placeholder="Quantity"
                              />
                            </Form.Item>
                          </td>

                          <td>
                            <Form.Item
                              name={`Since${element.index}`}
                              rules={[
                                {
                                  required: true,
                                  message: "Please select frequency",
                                },
                              ]}
                              // defaultValue={element.Since}
                              initialValue={element.Since}
                            >
                              <Dropdown
                                name="Since"
                                id="medications"
                                index={element.index}
                                data={sinceOptions}
                                options={{
                                  from: MEDICINE_REDUX_STATE,
                                  index: key,
                                  key: "Since",
                                }}
                                onChange={updateTable}
                                width={300}
                                placeholder="Select"
                                isV2
                                value={element.Since}
                              />
                            </Form.Item>
                          </td>
                          <td>
                            <Form.Item
                              name={`Status${element.index}`}
                              rules={[
                                {
                                  required: true,
                                  message: "Please select status",
                                },
                              ]}
                              // defaultValue={element.Status}
                              initialValue={element.Status}
                            >
                              <Dropdown
                                name="Status"
                                id="medications"
                                index={element.index}
                                data={statusOptions}
                                options={{
                                  from: MEDICINE_REDUX_STATE,
                                  index: key,
                                  key: "Status",
                                }}
                                onChange={updateTable}
                                width={190}
                                placeholder="Select"
                                isV2
                                value={element.Status}
                              />
                            </Form.Item>
                          </td>
                          <td>
                            <img
                              style={{ cursor: "pointer" }}
                              onClick={() => {
                                removeMedicine(
                                  element.index,
                                  element.Name ? element.Name : "Medicine"
                                );
                              }}
                              src={require("../../../../../../assets/InterBranch/PNGIcons/delete.png")}
                              alt=""
                            />
                          </td>
                        </tr>
                      );
                    })
                  ) : (
                    <tr>
                      <td colSpan={5}>
                        <div className="no-data">
                          <img
                            src={require("../../../../../../assets/InterBranch/PNGIcons/no_medicines.png")}
                            alt=""
                          />

                          <span>No data available</span>
                        </div>
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </Form>
        </div>
      </div>

      <div className="button-container">
        <button
          onClick={handleSave}
          disabled={!isEditted}
          className="submt-btn"
        >
          SAVE
        </button>

        {/* {
                    isScheduled() &&
                    <button className='join-btn' onClick={bookappointment}>BOOK APPOINTMENT</button>
                    // :
                    // <button disabled={!isCouponCodeVerified()} className='join-btn' onClick={() => setButtonClicked("Book")}>BOOK APPOINTMENT</button>
                } */}
        {
          !isScheduled() && (
            <button className="join-btn" onClick={videoconsultation}>
              SKIP AND JOIN CONSULTATION
            </button>
          )
          // :
          // <button disabled={!isCouponCodeVerified()} className='join-btn' onClick={() => setButtonClicked("Book")}>BOOK APPOINTMENT</button>
        }
      </div>
    </>
  );
}

export default AllergiesandMedication;
